import { UserItem } from "shared/api";
import { AdaptedValues } from "shared/types";

export const adaptUsersToOptions = (users: UserItem[]): AdaptedValues[] =>
  users
    ?.filter((user) => user?.id != null)
    .map((user) => ({
      label:
        `${user?.first_name ?? ""} ${user?.last_name ?? ""}`.trim() ||
        user?.username,
      value: user?.id!,
    })) || [];
